import ApiService from "./api.service";

const prepareFormSearch = function (form) {
  let query = {}
  query.issue_date_from = form.issue_date.start;
  query.issue_date_to = form.issue_date.end;

  let hasSubcontractors = false;
  if (form.filter.length > 0) {
    query.categories = [];
    for (let i = 0, n = form.filter.length; i < n; i++) {
      if (form.filter[i].flag) {
        hasSubcontractors = true;
      } else {
        query.categories.push(form.filter[i].id);
      }
    }
    //Kategoria nie została załączona
    if (hasSubcontractors && query.categories.indexOf(2) === -1) {
      query.categories.push(2);
    }
  }
  return query
}

const Bills = {
  create: async function (form) {
    let response = await ApiService.post("/bills", form);
    return response.data;
  },
  update: async function (id, form) {
    let response = await ApiService.put("/bills/" + id, form);
    return response.data;
  },
  delete: async function (id) {
    await ApiService.delete("/bills/" + id, {});
    return;
  },
  search: async function (form) {
    let response = await ApiService.get("/bills", prepareFormSearch(form));
    return response.data.bills;
  },
  loadCategories: async function (announcement) {
    let response = await ApiService.get("/bills/categories", announcement);
    return response.data.billscategories;
  },
  addCategory: async function (name) {
    let response = await ApiService.post("/bills/categories", {
      name: name
    });
    return response.data;
  },
  updateCategory: async function (id, name) {
    let response = await ApiService.put("/bills/categories/" + id, {
      name: name
    });
    return response.data;
  },
  deleteCategory: async function (id) {
    await ApiService.delete("/bills/categories/" + id);
  },
  unattachConstraction: async function (constructionid, billid) {
    await ApiService.delete("bills/" + billid + "/construction/" + constructionid);
  },
  doExportXls: async function (form) {
    let response = await ApiService.post("/bills/export", prepareFormSearch(form));
    return response.data.filename;
  },
  doConvertCurrency: async function (date, currency) {
    let response = await ApiService.get("tools/exchangerate/" + currency + "/eur/" + date);
    return response;
  }
};

export default Bills;